import React, { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import DeleteIcon from '@mui/icons-material/Delete';
import apiService from '../api/ApiService';

import { Link, json } from 'react-router-dom';
import S from './ListDam.module.css'
import D from '../images/messages.png'

import { useDispatch, useSelector } from 'react-redux';
import LoadingCop from '../Components/Loading';
import TicketNEw from '../Components/ViewTicketModal';
import { useGlobalContext } from '../Components/Context';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { toast } from 'react-toastify';
import { TicketList } from '../redux/slices/adminSlice';
import AddTicket from '../Components/AddTicket';
import TicketListt from '../Components/cardThemes/TicketList';
import { DateRange, SplitscreenOutlined, TitleOutlined } from '@mui/icons-material';
import { Pagination } from '@mui/material';
import { paginateCount } from '../api/helper';
import EmptyReturn from '../Components/EmptyReturn';

const moment=require('moment-jalaali')
const a=[
  {comp:'خوانده نشده',name:'ali',id:'1'},{comp:'خوانده شده',name:'ali',id:'2'}
]
export default function ListDam() {
  const {currentAdmin,tickets,currentTheme}=useSelector(state=>state.p.admin)
  const [statuses,setStatuses]=useState([])
  const [prop,setProp]=useState({});
  const dispatch=useDispatch();
  const [total,setTotal]=useState(1)
    const [page,setPage]=useState(0)
  const [Value,setValue]=useState(1);
  const [pbirth1,setpbirth]=useState('')
  const {openDeleteModal,isModalCommentOpen,closeModallComment,openModallComment,isDeleteModalOpen}=useGlobalContext();
  const getTicketStatuses=async()=>{
    const res=await apiService.getTicketStatus();
    setStatuses(res.data.data)
  }
  const getTickets=async()=>{
    const data=JSON.stringify({
      "skip": page?(page-1)*paginateCount:0,
      "take": paginateCount,
      "fromDate": null,
      "toDate":null,
      "title": null,
      "farmId": currentAdmin.id,
      "createUserId": null,
      "responseUserId": null,
      "ticketStatus": Value,
      "fromResponseDate": null,
      "toResponseDate": null
    })
   
    const res=await apiService.getTickets(data)

    dispatch(TicketList(res.data.data))
    setTotal(Math.ceil(res.data.totalCount/paginateCount))

  }
  const handlePage = (event, value) => {
    setPage(value);
  };
  useEffect(()=>{
    getTicketStatuses()
  },[])
  useEffect(()=>{
    getTickets()

  },[Value,page])
  return (
    <div className={S.AllAnimalssLICon}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} src={D}/>
        <h2>تیکت ها</h2>
        </div>
        <div onClick={()=>{openModallComment()}} data-title='افزودن  تیکت' className={`${S.CreateNewFarmBtn}`}>
                <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
           
      </div>
        <hr/>
        <div className={S.TabForAllAnnimLICon}>
          <div className={S.TabForAllAnnimbtnLICon}>
            {statuses.map((item,index)=>{
              return <div key={index} className={`${S.jobbtnLItab} ${index === Value-1 && S.ActiveLITab}`} onClick={()=>setValue(item?.id)} >{item.description}</div>
              

            })}
          </div>
          
          {!currentTheme&&<div className={S.AnimContentLI} data-aos='fade'>
          {tickets?.length?<table>
              <thead>
              <tr>
                  <th>
                  <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>
                  </th>
                  
                  <th>
                  <div className='LogoFormT'><div><span>
                <TitleOutlined/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                  </th>
                  
                  <th>
                  <div className='LogoFormT'><div><span>
                <InfoIcon/>
                </span>
                    </div></div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ردیف
                  </th>
                  
                  <th>
                    عنوان
                  </th>
                  <th>
                     تاریخ
                  </th>
                  
                  <th>
                    جزئیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  tickets&&tickets?.map((item,index)=>{
                    
                    const {createDate}=item;
                    const birth=createDate?.substring(0,19);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD HH:mm')
                    return <tr key={index}>
                    <td>
                    {(index+1)+(page==0?0:page-1)*8}
                    </td>
                    
                    
                    <td>
                      {item?.title}
                    </td>
                    <td>
                      {pbirth}
                    </td>
                    
                    <td className={S.DetIc}>
                      <Link onClick={()=>{openDeleteModal();setpbirth(pbirth);setProp(item)}} >
                      <div className='btnCardDAm'> مشاهده</div>

                      </Link>
                      
                      
                    </td>
                  </tr>
                  
                  })
                }
              </tbody>
            </table>:<EmptyReturn/>}
          </div>}
          {currentTheme&&<TicketListt flag={Value}/>}
        </div>
        <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
        {!currentTheme&&isDeleteModalOpen&&<TicketNEw flag={Value} data={prop} time={pbirth1}/>}
      {isModalCommentOpen&&<AddTicket/>}
    </div>
  );
}